export default __webpack_public_path__ + "static/media/809.66df6d7c.png";